const mobileNav = () => {
  // Elements
  const body = document.getElementsByTagName('body')[0];
  const menuBtn = document.querySelector('.mobile-menu > button');
  const mobileHeaderDiv = document.querySelector('.nav-wrapper-mobile');
  const menuDiv = document.querySelector('.mobile-flyout');
  const mobileSubmenus = document.querySelectorAll('.nav-wrapper-mobile .subnav-toggle-btn');
  // Hide flyout on load
  if (menuDiv !== null) {
    menuDiv.setAttribute('style', 'display:none;');
  }

  const toggleMobileSubMenuState = (btn, state) => {
    const parent = btn.parentNode.parentNode;
    if (state) {
      parent.classList.remove('subnav-open');
      btn.setAttribute('aria-expanded', 'false');
      // parent.classList.remove('open');
    } else {
      parent.classList.add('subnav-open');
      btn.setAttribute('aria-expanded', 'true');
      // parent.classList.add('open');
    }
  };

  const onBodyClickOffNav = (bodyEvent) => {
    if (bodyEvent.target.classList.contains('mobile-flyout-bg')) {
      toggleMenuState(); /* eslint-disable-line no-use-before-define */
    }
  };

  const toggleMenuState = () => {
    if (mobileHeaderDiv.classList.contains('open')) {
      mobileHeaderDiv.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
      // Remove body click event handler
      body.removeEventListener('click', onBodyClickOffNav);
      const timer = setTimeout(() => {
        menuDiv.setAttribute('style', 'display:none;');
        // Close any open submenus, IE 11
        for (let i = 0; i < mobileSubmenus.length; i++) { /* eslint-disable-line no-plusplus */
          toggleMobileSubMenuState(mobileSubmenus[i], true);
        }
        clearTimeout(timer);
      }, 450);
    } else {
      menuDiv.setAttribute('style', 'display:block;');
      // Add body click event handler
      body.addEventListener('click', onBodyClickOffNav);
      const timer = setTimeout(() => {
        mobileHeaderDiv.classList.add('open');
        menuBtn.setAttribute('aria-expanded', 'true');
        clearTimeout(timer);
      }, 150);
    }
  };
  // Add events
  // Open Mobile Menu
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      toggleMenuState();
    });
  }
  // Toggle Mobile Submenus
  if (mobileSubmenus) {
    [].map.call(mobileSubmenus, btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      toggleMobileSubMenuState(btn, btn.parentNode.parentNode.classList.contains('subnav-open'));
    }));
  }
};

export default mobileNav;
